export default "__VITE_ASSET__BFe_fR9v__"